import DesktopPremiumWindStationCTA from './DesktopPremiumWindStationCTA';
import MobilePremiumWindStationCTA from './MobilePremiumWindStationCTA';

export { DesktopPremiumWindStationCTA, MobilePremiumWindStationCTA };
